import { useEffect, useState, useRef } from 'react';
import { Box, MenuItem, Button, List, ListItemButton, ListItemText, Collapse } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useLocation } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { isPathArrayActive } from '../../Utilities/HelperMethods';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import {
  NavMenu,
  navButtonStyles,
  navButtonActiveStyles,
  menuItemStyles,
} from './StyledComponents';

export const MoreMenuItem = ({ user, toggleDrawer }) => {
  const [open, setOpen] = useState(false);
  const moreAnchorRef = useRef(null);
  const location = useLocation();
  const isMedium = useMediaQuery('(max-width:1200px)');
  const isMobile = useMediaQuery('(max-width:600px)');
  const basePaths = ['/News', '/Onboarding'];
  const isActive = isPathArrayActive(location.pathname, basePaths);
  const [mobileOpen, setMobileOpen] = useState(isActive ? true : false);

  const handleToggle = (event) => {
    setOpen((prevOpen) => !prevOpen);
    moreAnchorRef.current = event.currentTarget;
  };

  const handleClose = (event) => {
    if (moreAnchorRef.current && moreAnchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleMobileToggle = () => {
    setMobileOpen((prevOpen) => !prevOpen);
  };

  useEffect(() => {
    setOpen(false);
  }, [location]);

  const MobileMenuItemStyle = {
    display: 'flex !important',
    padding: '8px 16px !important',
    flexGrow: '0',
  };
  if (isMedium || isMobile) {
    return (
      <List sx={{ width: '100%', bgcolor: 'background.paper', padding: '0px !important' }}>
        <ListItemButton sx={MobileMenuItemStyle} onClick={handleMobileToggle}>
          <ListItemText primary="More" />
          {mobileOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={mobileOpen} timeout="auto">
          <List
            component="div"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              borderLeft: '1px solid #2CA6FA',
              marginLeft: '1rem',
            }}
            disablePadding
          >
            <ListItemButton
              sx={{
                ...MobileMenuItemStyle,
                pl: 4,
                background: location.pathname.includes('/News') ? '#0000000a !important' : '',
              }}
              component={NavLink}
              onClick={toggleDrawer}
              to="/News"
            >
              <ListItemText primary="News" />
            </ListItemButton>

            {user.permissions.Recruitment && (
              <ListItemButton
                sx={{
                  ...MobileMenuItemStyle,
                  pl: 4,
                  background: location.pathname.includes('/Onboarding')
                    ? '#0000000a !important'
                    : '',
                }}
                component={NavLink}
                onClick={toggleDrawer}
                to="/Onboarding"
              >
                <ListItemText primary="Onboarding" />
              </ListItemButton>
            )}
          </List>
        </Collapse>
      </List>
    );
  }

  return (
    <Box style={{ borderRadius: 'none' }}>
      <Button
        ref={moreAnchorRef}
        onClick={handleToggle}
        sx={{
          ...navButtonStyles,
          ...(isActive && {
            ...navButtonActiveStyles,
          }),
        }}
      >
        More
      </Button>
      <NavMenu anchorEl={moreAnchorRef.current} open={open} onClose={handleClose}>
        <Box>
          {/*<MenuItem sx={{
                        ...menuItemStyles,
                        background: location.pathname.includes('/Training') ? '#0000000a' : ''
                    }} component={NavLink} to={'/Training'}>Training</MenuItem>*/}
          <MenuItem
            sx={{
              ...menuItemStyles,
              background: location.pathname.includes('/News') ? '#0000000a' : '',
            }}
            component={NavLink}
            to={'/News'}
          >
            News
          </MenuItem>
          {user.permissions.Recruitment && (
            <MenuItem
              sx={{
                ...menuItemStyles,
                background: location.pathname.includes('/Onboarding') ? '#0000000a' : '',
              }}
              component={NavLink}
              to={'/Onboarding'}
            >
              Onboarding
            </MenuItem>
          )}
          {/*(user.division === 'CASG' || user.isHO) && <MenuItem sx={{
                        ...menuItemStyles,
                        background: location.pathname.includes('/Marketing') ? '#0000000a' : ''
                    }} component={NavLink} to={'/Marketing'}>Marketing</MenuItem>*/}
        </Box>
      </NavMenu>
    </Box>
  );
};
